import { imgMap, colorMap, formatTime } from '@/utils';

export default {
  data() {
    return {
      loading: true,
      imgMap,
      colorMap,
      dataList: [],
      cellHeight: 55,
      headHeight: 30,
      lineNumber: 10,
      classes: '',
      headClasses: '',
      bodyClasses: '',
      lineClass: '',
      // 数据相关
      count: 0, // 总条数
      page: 1, // 当前page
      pageSize: 10, // 每页显示
      startTime: '',
      endTime: '',
      uidValue: '',
      phoneValue: '',
      coinType: 'all',
      type: 'all',
      lowerType: 'all',
      returnStatus: '', // 结算状态
      // level: '', // 被邀请人级别
    };
  },
  computed: {
    personTypeList() {
      return [
        { label: this.$t('brokerSystem.commissionTable[12]'), value: this.$t('brokerSystem.commissionTable[12]'), code: 1 },
        { label: this.$t('brokerSystem.commissionTable[13]'), value: this.$t('brokerSystem.commissionTable[13]'), code: 2 },
      ];
    },
    returnStatusList() {
      return [
        { label: this.$t('brokerSystem.commissionTable[11]'), value: this.$t('brokerSystem.commissionTable[11]'), code: 0 }, // 未结算
        { label: this.$t('brokerSystem.commissionTable[10]'), value: this.$t('brokerSystem.commissionTable[10]'), code: 1 }, // 已结算
      ];
    },
    returnTypeList() {
      return [
        { label: this.$t('brokerSystem.commissionTable[2]'), value: this.$t('brokerSystem.commissionTable[2]'), code: 1 }, // 一级返佣
        { label: this.$t('brokerSystem.commissionTable[3]'), value: this.$t('brokerSystem.commissionTable[3]'), code: 2 }, // 二级返佣
      ];
    },
    typeList() {
      return [
        // 全部
        { code: 'all', key: 'type', value: this.$t('order.otcOrder.all') },
      ];
    },
    coinTypeList() {
      return [
        // 全部
        { code: 'all', key: 'coinType', value: this.$t('order.otcOrder.all') },
      ];
    },
    lowerTypeList() {
      return [
        // 全部
        { code: 'all', key: 'lowerType', value: this.$t('order.otcOrder.all') },
      ];
    },
    startTimeNum() {
      return (new Date(this.startTime.replace(/-/g, '/')).getTime() / 1000).toString();
    },
    endTimeNum() {
      return (new Date(this.endTime.replace(/-/g, '/')).getTime() / 1000).toString();
    },
    startTimeText() {
      return this.$t('broker.startTime');
    },
    endTimeText() {
      return this.$t('freeStaking.myPos.endTime');
    },
    navTab() {
      return [
        {
          name: this.$t('brokerSystem.commissionNavTab[0]'),
          index: 1,
        },
        {
          name: this.$t('brokerSystem.commissionNavTab[1]'),
          index: 2,
        },
      ];
    },
    columns() {
      return [
        {
          title: this.$t('brokerSystem.lowerTable1[0]'),
          align: 'left',
          width: '16%',
          classes: '',
        },
        {
          title: this.$t('brokerSystem.lowerTable[11]'),
          align: 'left',
          width: '15%',
        },
        {
          title: this.$t('brokerSystem.lowerTable1[7]'),
          align: 'left',
          width: '15%',
        },
        {
          title: this.$t('brokerSystem.lowerTable1[8]'),
          align: 'left',
          width: '15%',
        },
        {
          title: this.$t('brokerSystem.lowerTable1[3]'),
          align: 'left',
          width: '15%',
        },
        {
          title: this.$t('brokerSystem.otherText[3]'),
          align: 'right',
          width: '15%',
        },
      ];
    },
  },
  methods: {
    init() {
      this.startTime = this.getNowTime(this.getMonth(-1));
      this.endTime = this.getNowTime(this.getMonth(0));
    },
    getData() {
      this.axios({
        url: 'coAgent/next/records',
        params: {
          page: this.page,
          limit: this.pageSize,
          beginTime: new Date(this.startTime).getTime(),
          endTime: new Date(this.endTime).getTime(),
          uid: this.uidValue || undefined,
          // type: this.level,
          returnStatus: this.returnStatus,
        },
      }).then((data) => {
        this.loading = false;
        if (data.code.toString() === '0') {
          this.count = data.data.count;
          const arr = [];
          data.data.list.forEach((item, index) => {
            // const fix = this.getFix(item.coin.toUpperCase());
            arr.push({
              id: index,
              data: [
                item.ctime ? formatTime(item.ctime) : '--', // 注册时间
                // this.getLabel(this.returnTypeList, item.returnType), // 返佣类型
                item.uid, // uid
                item.tradeSymbol, // 交易币对
                item.tradeAmount, // 交易额
                item.returnAmount, // 返佣金额
                this.getLabel(this.returnStatusList, item.returnStatus), // 结算状态
              ],
            });
          });
          this.dataList = arr;
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
    getLabel(arr, val) {
      const temp = arr.filter((item) => item.code === val);
      return temp.length ? temp[0].label : '';
    },
    getMonth(n) {
      const date = new Date();
      return date.setMonth(date.getMonth() + n);
    },
    getNowTime(time = '') {
      const date = new Date(time);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();

      return `${year}-${month}-${day}`;
    },
    setStartTime(time) {
      this.startTime = time;
      this.page = 1;
      this.loading = true;
      this.getData();
    },
    setEndTime(time) {
      this.endTime = time;
      this.page = 1;
      this.loading = true;
      this.getData();
    },
    currentType(data) {
      this.currentTab = data.index;
    },
    reducePost() {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {

      }, 500);
    },
    inputChanges(value, name) {
      this[name] = value;
      this.page = 1;
      this.loading = true;
      this.getData();
    },
    setSelect(item) {
      this[item.key] = item.code;
    },
    // levelChange(item) {
    //   this.level = item.code;
    //   this.loading = true;
    //   this.page = 1;
    //   this.getData();
    // },
    statusChange(item) {
      this.returnStatus = item.code;
      this.loading = true;
      this.page = 1;
      this.getData();
    },
    pagechange(v) {
      this.page = v;
      this.getData();
    },
  },
};
